import type { IAlias } from '../model/IAlias'

export function getPersonAliasFormatted(alias: IAlias) {
	return (
		<>
			{alias.honorific ? <small>{alias.honorific}</small> : ''}{' '}
			{alias.lastName ?? ''} <b>{alias.firstName ?? ''}</b>
		</>
	)
}
